import React from 'react'
export const Nav00DataSource = {
  wrapper: { className: 'header0 home-page-wrapper' },
  page: { className: 'home-page' },
  logo: {
    className: 'header0-logo',
    children: 'https://cbdata-index-1259417822.cos.ap-nanjing.myqcloud.com/%E7%BC%96%E7%BB%84.png',
  },
  Menu: {
    className: 'header0-menu',
    children: [],
  },
  mobileMenu: { className: 'header0-mobile-menu' },
}
export const Banner00DataSource = {
  wrapper: { className: 'banner0 ldnxsst0hrs-editor_css' },
  textWrapper: { className: 'banner0-text-wrapper' },
  title: {
    className: 'banner0-title ldnxfv7giw-editor_css',
    children: 'https://zos.alipayobjects.com/rmsportal/HqnZZjBjWRbjyMr.png',
  },
  content: {
    className: 'banner0-content ldnxesfsmg-editor_css',
    children: <span>{/* <p>宸邦信息技术有限公司</p> */}</span>,
  },
  button: {
    className: 'banner0-button ldnxg9kf1b-editor_css',
    children: <span></span>,
  },
}
export const Content10DataSource = {
  wrapper: { className: 'home-page-wrapper content1-wrapper' },
  OverPack: { className: 'home-page content1', playScale: 0.3 },
  imgWrapper: { className: 'content1-img', md: 10, xs: 24 },
  img: {
    // children: 'https://a-fxb-cdn.cbyzx.com/fxbb3172a68xzgke/img/5a90963b28d4454f88150236b973d701@.png'
    children:
      'https://smartxx-cdn.cbyzx.com/D00717580/img/7a442c834415474d9718e9a63800f225@.png',
  },
  textWrapper: { className: 'content1-text', md: 14, xs: 24 },
  title: {
    className: 'content1-title',
    children: <span>我的新乡</span>,
  },
  content: {
    className: 'content1-content',
    children: (
      <div>
        <p  style={{
          textIndent: '20px'
        }}>
          “我的新乡”APP是在新乡市市委、市政府的指导下，由新乡广播电视台、新乡市行政审批和政务信息管理局合作，新乡市首个集新闻资讯、便民服务、社区生活于一体的综合性城市生活服务APP。
        </p>
        <p style={{
          textIndent: '20px'
        }}>
        “我的新乡"APP的建设，着眼于本地服务，宣传市委市政府的各项工作精神和便民惠民政策，整合汇集本市高频次便民服务，提供本地社区生活服务的移动端城市服务入口。通过加强与社会化机构、商家或平台合作，拓展城市服务渠道，以市民为中心，以解决市民生活需求为目标，构建移动端便民服务体系，为新乡市民打造一个最权威、最接地气的城市生活服务APP。
        </p>
        <div className="download-btn">敬请期待</div>
      </div>
    ),
  },
}
export const Content00DataSource = {
  wrapper: { className: 'home-page-wrapper content0-wrapper' },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>产品功能</p>
          </span>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        md: 6,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon ldnyctpecc8-editor_css',
              children:
                'https://smartxx-cdn.cbyzx.com/D00717580/img/612e01881be44e6e86573e645ef9e0f1@.jpeg',
            },
            {
              name: 'title',
              className: 'content0-block-title ldnycyv8mx-editor_css',
              children: '一站式业务接入',
            },
            {
              name: 'content',
              children: '支付、结算、核算接入产品效率翻四倍',
              className: 'ldnyd10vgo-editor_css',
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'content0-block',
        md: 6,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon ldnydyq43nb-editor_css',
              children:
                'https://smartxx-cdn.cbyzx.com/D00717580/img/e8952f0bd9e8409ca715451dbe7e5f00@.jpeg',
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'content0-block',
        md: 6,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon ldnydyq43nb-editor_css',
              children:
                'https://smartxx-cdn.cbyzx.com/D00717580/img/1464c84fcd6a48e68492dbeabe0d7879@.jpeg',
            },
          ],
        },
      },
      {
        name: 'block3',
        className: 'content0-block',
        md: 6,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon ldnydyq43nb-editor_css',
              children:
                'https://smartxx-cdn.cbyzx.com/D00717580/img/40acc6fd8f9141f0b2b6a46313bd8b53@.jpeg',
            },
          ],
        },
      },
    ],
  },
}
export const Footer00DataSource = {
  wrapper: { className: 'home-page-wrapper footer0-wrapper' },
  OverPack: { className: 'home-page footer0', playScale: 0.05 },
  copyright: {
    className: 'copyright',
    children: (
      <span>
        <span>
          <p>
            <span>
              ©2019-2025 &nbsp;我的新乡 中国·新乡广播电视台版权所有&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
            <a href="https://beian.miit.gov.cn">豫ICP备07003144号</a>
          </p>
        </span>
      </span>
    ),
  },
}
